import React, { Component } from 'react';
import { array } from 'prop-types';
import { Button, Modal, Table } from 'antd';

import API from '../../../api';
import { promiseLoader, refreshAll } from '../../common/promise-loader';
import { history } from '../../common/custom-router';
import deleteIcon from '../../../assets/images/sales-processes-delete.svg';

class MetaStagesList extends Component {
  static propTypes = {
    metaStages: array
  };

  onDelete = (record) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    Modal.confirm({
      title: '¿Estás seguro que deseas eliminar esta etapa?',
      content: 'Esta acción no se puede deshacer.',
      onOk: async () => {
        await API.staff.deleteMetaStage(record.id);
        refreshAll();
      }
    });
  };

  render () {
    const { metaStages } = this.props;
    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name'
      },
      {
        title: 'Acciones',
        key: 'actions',
        render: (_, record) => (
          <Button type="link" onClick={this.onDelete(record)}>
            <img src={deleteIcon} alt="delete icon"/>
          </Button>
        )
      }
    ];
    return (
      <div>
        <Table
          locale={{ emptyText: 'Sin etapas' }}
          showSorterTooltip={false}
          dataSource={metaStages}
          columns={columns}
          onRow={(record, rowIndex) => ({
            onClick: (event) => history.push(`/staff/meta_stages/${record.id}`)
          })}
        />
      </div>
    );
  }
}

export default promiseLoader(
  () => API.staff.getMetaStages(),
  'metaStages'
)(MetaStagesList);
